import icon from './cycleCount.svg'

/**
 * CycleCount base route.
 *
 * @namespace routes.OperationCycleCount
 * @type {TmrRoute}
 */
export const route = {
  name: 'operations.cycleCount',
  redirectTo: 'app.operations.cycleCount.list',
  label: 'OPERATIONS.CYCLECOUNT.TITLE',
  accessControl: ['Operation.perform', 'Operation.CycleCount.perform'],
  weight: 4,
  icon,
  abstract: false,
}
